// extracted by mini-css-extract-plugin
export default {"wrapper":"hrrc_D2Wrm_pdp","block":"VeNqLe8AYC_pdp"};